import React, {createRef, memo, useCallback, useRef} from "react";
import './ResponsiveList.scss'
import AutoSizer from "react-virtualized-auto-sizer";
import {VariableSizeList} from "react-window";
import ResponsiveRow from "./ResponsiveRow";
import ResponsiveScrollbars from "./ResponsiveScrollbars";
import memoizeOne from "memoize-one";

const createItemData = memoizeOne((items, setRowHeight, ItemElementType) => ({
    items, setRowHeight, ItemElementType
}));

const ResponsiveList = memo(({itemData: data, ItemElementType, availableHeight}) => {
    const listRef = createRef();
    const rowHeights = useRef({});
    const {available, max} = availableHeight;

    const getRowHeight = (index) => (rowHeights.current[index] + 2 || 34);

    const setRowHeight = useCallback((index, size) => {
        listRef.current.resetAfterIndex(0);
        rowHeights.current = {...rowHeights.current, [index]: size}
    }, [listRef])

    const itemData = createItemData(data, setRowHeight, ItemElementType);

    return (<AutoSizer disableHeight={available < max / 2}>
        {({height, width}) =>
            <VariableSizeList
                height={height || max}
                width={width}
                itemData={itemData}
                itemKey={index => `row_${data[index].index}`}
                itemCount={data.length}
                itemSize={getRowHeight}
                ref={listRef}
                outerElementType={ResponsiveScrollbars}>
                {ResponsiveRow}
            </VariableSizeList>}
    </AutoSizer>);
});

export default ResponsiveList;